import jadekenneth from './img/jadekenneth.jpg';

export const login_data = [
    {
        id: 1,
        profile: jadekenneth,
        username: "Jade Kenneth",
        isLogged: false,
        lastname: "Darunday",
        email: 'jadesapero@hotmail.com',  
        password: "darunday",
        lived: "Madrid, Spain",
        pic: "https://www.tourist-destinations.com/wp-content/uploads/2012/03/madridspain.jpg",
        job: "Programmer Hub"
    },
    {
        id: 2,
        profile: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.gkf3yxICbp-OJc1JfJcq6gHaHB%26pid%3DApi&f=1',   
        email: 'markzucker@hotmail.com',
        username: "Mark",
        isLogged: false,
        lastname: "Zuckerberg",
        password: "zuckerberg",
        pic: "https://static.thousandwonders.net/Metro.Manila.original.6748.jpg",
        lived: "Manila City",
        job: "Bodyguard"
    },
    {
        
        id: 3,
        profile: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.pyCIsX24XnxyfMtsjuJvQAHaE8%26pid%3DApi&f=1',
        email: 'billgates@hotmail.com',
        username: "Bill",
        isLogged: false,
        lastname: "Gates",
        password: "gates",
        pic: "https://static.thousandwonders.net/Metro.Manila.original.6748.jpg",
        lived: "Cebu City",
        job: "Resto bar"
    }
    
];


